import React from "react";
import { Link } from "react-router-dom";

export default function OurTeamSection({ data }) {
  if (!data) return null;

  return (
    <section className="our-team-section">
      <div className="container">
        <div className="our-team-section-heading text-center">
          <span>{data.eyebrow}</span>
          <h2 className="heading">{data.title}</h2>
        </div>

        <div className="row justify-content-center our-team-section-cards">
          {data.members.map((member) => (
            <div className="col-lg-4 col-md-6 col-sm-12" key={member.name}>
              <article className="team-member-card" tabIndex="0">
                <img src={member.image} alt={member.imageAlt || member.name} />
                <div className="team-member-card-shade" />
                <div className="team-member-card-summary">
                  <p>{member.role}</p>
                 <div className="name">{member.name}</div>
                </div>
                <div className="team-member-card-details">
                  <p className="team-member-card-role">{member.role}</p>
                  <div className="name">{member.name}</div>
                  {member.phone && (
                    <p>
                      <strong>T:</strong>{" "}
                      <a href={`tel:${member.phone.replace(/\s/g, "")}`}>
                        {member.phone}
                      </a>
                    </p>
                  )}
                  {member.email && (
                    <p>
                      <strong>E:</strong>{" "}
                      <a href={`mailto:${member.email}`}>{member.email}</a>
                    </p>
                  )}
                  {member.cta?.link && (
                    <Link className="default-btn" to={member.cta.link}>
                      {member.cta.label}
                    </Link>
                  )}
                </div>
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
